import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchSsoOrganization } from '@/api/(admin)/sso';
import { ssoQueryKey } from './useSsoOrganizations';

export const ssoOrganizationQueryOptions = (id: string) =>
  queryOptions({
    queryKey: [...ssoQueryKey, 'organization', id] as const,
    queryFn: () => fetchSsoOrganization(id),
  });

export function useSsoOrganizationDetail(id: string) {
  const query = useQuery(ssoOrganizationQueryOptions(id));
  return { ...query, organization: query.data?.data ?? null };
}
